import { ChatsCircle } from "@phosphor-icons/react";

import { HookObject, ListItemsHooks } from "@/plugins/types";
import { LaunchInbox } from "./LaunchInbox";

// LI-5 — Launch Inbox: the team inbox (email, website chat), built on Chatwoot Community
// Edition and signed in with the Launch OS login. Shown only with the "inbox" permission —
// the bridge checks the same permission, so admins without it get a plain "not turned on".
const canSee = (permissions: string[] = []) => permissions.includes("inbox");

export const onListItems = (hook: HookObject, _: unknown, __: unknown, { permissions = [] as string[] }) => {
  if (hook.id === ListItemsHooks.APP_DRAWER && hook.position === "top") {
    if (!canSee(permissions)) return [];
    return [{ label: "Launch Inbox", icon: <ChatsCircle className="text-lg" />, href: "/inbox", order: 1.6 }];
  }
  if (hook.id === ListItemsHooks.ROUTES) {
    if (!canSee(permissions)) return [];
    return [{ path: "/inbox", element: <LaunchInbox /> }];
  }
};

export { LaunchInbox };
